import {
	get,
	post
} from './http'

import axios from 'axios';
import urlencode from "urlencode";
import baseUrl from '../utils/config.js'

const REPORT_URL_HOST = process.env.REPORT_URL_HOST;

let apiUrl = '';
switch (process.env.NODE_ENV) {
	case 'development':
		apiUrl = baseUrl.devApiHost;
		break;
	case 'release':
		apiUrl = baseUrl.releaseApiHost;
		break;
	case 'tmkRelease':
		apiUrl = baseUrl.tmkReleaseApiHost;
		break;
	default:
		apiUrl = baseUrl.proApiHost;
}

export default {

	GetPurchaseClass(token) {
		return get('api/BaseData/GetPurchaseClass', {
			token: token,
		});
	},

	CreateDeptBudget(token, data) {
		return post('api/Finance/CreateDeptBudget', {
			token: token,
			data: data,
		});
	},

	GetDepartFiscalYearList(token, deptid) {
		return get('api/Finance/GetDepartFiscalYearList', {
			token: token,
			deptid: deptid,
		});
	},

	GetDepartBudgetList(token, search, key, common, page, recordCount) {
		return post('api/Finance/GetDepartBudgetList', {
			token: token,
			search: search,
			type: '',
			key: key,
			common: common,
			page: page,
			recordCount: recordCount
		});
	},

	GetDepartBudgetInfo(token, deptid, applyDt, id = 0, BudgetType = "") {
		return get('api/Finance/GetDepartBudgetInfo', {
			token,
			deptid,
			applyDt,
			id,
			BudgetType
		});
	},

	SetDepartBudget(token, data) {
		return post('api/Finance/SetDepartBudget', {
			token: token,
			data: data
		});
	},

	GetExchangeRateList(token, search, type) {
		return get('api/Finance/GetExchangeRateList', {
			token,
			search,
			type
		});
	},

	CreateOrEditExchangeRate(token, data) {
		return post('api/Finance/CreateOrEditExchangeRate', {
			token: token,
			data: data
		});
	},

	EditDepartBudget(token, data) {
		return post('api/Finance/EditDepartBudget', {
			token: token,
			data: data
		});
	},

	GetPaymentApplicationForm(token, id, ponum) {
		return get('api/Finance/GetPaymentApplicationForm', {
			token,
			id,
			ponum
		});
	},

	GetApplicationPayList(token, ponum, invoice, isPoOnly, supplierName, status, startDt, endDt, payStatus, page,
		recordCount) {
		return post('api/Finance/GetApplicationPayList', {
			token,
			ponum,
			invoice,
			isPoOnly,
			supplierName,
			status,
			startDt,
			endDt,
			payStatus,
			page,
			recordCount
		});
	},

	CreateOrEditApplicationPay(token, data) {
		return post('api/Finance/CreateOrEditApplicationPay', {
			token,
			data
		});
	},

	GetApplyPayInfo(token, id) {
		return get('api/Finance/GetApplyPayInfo', {
			token,
			id
		});
	},

	DealApplicationPay(token, appid, paydt, remark) {
		return post('api/Finance/DealApplicationPay', {
			token,
			appid,
			paydt,
			remark
		});
	},

	GetAccountingSubjectList(token, search, page, recordCount) {
		return get('api/Finance/GetAccountingSubjectList', {
			token,
			search,
			page,
			recordCount,
		});
	},

	GetBudgetTypeList(token) {
		return get('api/Finance/GetBudgetTypeList', {
			token
		});
	},

	CreateOrEditAccountingSubject(token, data) {
		return post('api/Finance/CreateOrEditAccountingSubject', {
			token,
			data,
		});
	},

	CreateOrEditBudgetType(token, data) {
		return post('api/Finance/CreateOrEditBudgetType', {
			token,
			data,
		});
	},

	GetAccountNOTemplate(token, purid, deptid, groupid, itemid, ProjectID = 0) {
		return get('api/Finance/GetAccountNOTemplate', {
			token,
			purid,
			deptid,
			groupid,
			itemid,
			ProjectID
		});
	},

	CreateOrEditAccountNOTemplate(token, data, ) {
		return post('api/Finance/CreateOrEditAccountNOTemplate', {
			token,
			data,
		});
	},

	UpdatePaymentInfo(token, data, ) {
		return post('api/Finance/UpdatePaymentInfo', {
			token,
			data,
		});
	},

	GetPOOfRequestDetail(token, ponum) {
		return get('api/Finance/GetPOOfRequestDetail', {
			token,
			ponum,
		});
	},

	SetApplicationPayState(token, id) {
		return post('api/Finance/SetApplicationPayState', {
			token,
			data: {
				id
			}
		})
	},

	InvalidApplicationPayRecord(token, id) {
		return post('api/Finance/InvalidApplicationPayRecord', {
			token,
			data: {
				id
			}
		})
	},

	ExportInvoiceContent(token, id) {
		return apiUrl + `api/Finance/ExportInvoiceContent?token=${token}&id=${id}`;
	},

	UpdateInvoice(token, data) {
		return post(`api/Finance/UpdateInvoice`, {
			token,
			data
		})
	},

	GetNoInvoiceAPList(Days = 30) {
		return get(`api/Finance/GetNoInvoiceAPList`, {
			Days
		})
	}
}


// WEBPACK FOOTER //
// ./src/request/financialApi.js